export let InvoiceIntegrationStatusEnum;

(function (InvoiceIntegrationStatusEnum) {
  InvoiceIntegrationStatusEnum["PendingSync"] = "pendingSync";
  InvoiceIntegrationStatusEnum["InvoiceSyncFailed"] = "invoiceSyncFailed";
  InvoiceIntegrationStatusEnum["PaymentSyncFailed"] = "paymentSyncFailed";
  InvoiceIntegrationStatusEnum["RefundSyncFailed"] = "refundSyncFailed";
  InvoiceIntegrationStatusEnum["InvoiceRecorded"] = "invoiceRecorded";
  InvoiceIntegrationStatusEnum["VoidedRecorded"] = "voidedRecorded";
  InvoiceIntegrationStatusEnum["RefundRecorded"] = "refundRecorded";
  InvoiceIntegrationStatusEnum["PaymentRecorded"] = "paymentRecorded";
})(InvoiceIntegrationStatusEnum || (InvoiceIntegrationStatusEnum = {}));

export let InvoiceIntegrationFailureCodeOld;

(function (InvoiceIntegrationFailureCodeOld) {
  InvoiceIntegrationFailureCodeOld["ArchivedData"] = "archivedData";
  InvoiceIntegrationFailureCodeOld["Unknown"] = "unknown";
})(InvoiceIntegrationFailureCodeOld || (InvoiceIntegrationFailureCodeOld = {}));

export let InvoiceIntegrationFailureCode;

(function (InvoiceIntegrationFailureCode) {
  InvoiceIntegrationFailureCode["Unknown"] = "unknown";
  InvoiceIntegrationFailureCode["DuplicateDocumentNumberError"] = "duplicate_document_number_error";
  InvoiceIntegrationFailureCode["AmountCalculationIncorrect"] = "amount_calculation_incorrect";
  InvoiceIntegrationFailureCode["CustomerDeleted"] = "customer_deleted";
  InvoiceIntegrationFailureCode["ItemDeleted"] = "item_deleted";
  InvoiceIntegrationFailureCode["ClassDeleted"] = "class_deleted";
  InvoiceIntegrationFailureCode["InvoiceAmountNotMatching"] = "invoice_amount_not_matching";
  InvoiceIntegrationFailureCode["ObjectNotFound"] = "object_not_found";
  InvoiceIntegrationFailureCode["AccountDeleted"] = "account_deleted";
  InvoiceIntegrationFailureCode["VendorDeleted"] = "vendor_deleted";
  InvoiceIntegrationFailureCode["InvoicePaid"] = "invoice_paid";
  InvoiceIntegrationFailureCode["DepositTotalAmountNotMatching"] = "deposit_total_amount_not_matching";
  InvoiceIntegrationFailureCode["TransactionCannotBeAppliedToDeposit"] = "transaction_cannot_be_applied_to_deposit";
  InvoiceIntegrationFailureCode["InvoiceDeleted"] = "invoice_deleted";
  InvoiceIntegrationFailureCode["PaymentDeleted"] = "payment_deleted";
  InvoiceIntegrationFailureCode["AccountPeriodClosed"] = "account_period_closed";
})(InvoiceIntegrationFailureCode || (InvoiceIntegrationFailureCode = {}));